export default "__VITE_ASSET__630f26db__"